import { SmartphoneOutlined } from "@mui/icons-material";
import {
  alpha,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";
import CustomDialog from "Components/CustomDialog/CustomDialog";
import { useMobileDashboardNotice } from "features/project/hooks/useMobileDashboardNotice";

interface IMobileDashboardNoticeDialogProps {
  isMobile: boolean;
}

function MobileDashboardNoticeDialog({
  isMobile,
}: IMobileDashboardNoticeDialogProps) {
  const { shouldShow, dismiss } = useMobileDashboardNotice(isMobile);

  return (
    <CustomDialog
      open={shouldShow}
      isConfirmation
      showClose={false}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 64,
              height: 64,
              borderRadius: "50%",
              mb: 2,
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              color: theme.palette.primary.main,
            })}
          >
            <SmartphoneOutlined sx={{ fontSize: 32 }} />
          </Box>
          <Typography variant="h6" fontWeight={700}>
            Mobile dashboard only
          </Typography>
        </Box>
        <DialogContentText component="div">
          <p>
            On mobile, only the project dashboard is available. You can still
            view your key metrics, switch tabs, and open quick insights.
          </p>
          <p>
            For reports, settings, and the full Incendium experience, please
            open this project on a desktop or laptop.
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" fullWidth size="small" onClick={dismiss}>
          OK
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}

export default MobileDashboardNoticeDialog;
